/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useEffect, useState } from "react";
import { useToasts } from "react-toast-notifications";
import { getCurrentUser } from "../auth/service";
import { Router } from "react-router-dom";

const HomePg = () => {
  const { addToast } = useToasts();
  const [isLoading, setIsLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  useEffect(() => {
    async function loadUser() {
      try {
        const currentUser = await getCurrentUser();
        setCurrentUser(currentUser);
        setIsLoading(false);
      } catch (error) {
        addToast("Token Expired :(", {
          appearance: "error",
        });
        Router.push("/auth/login");
        setIsLoading(false);
      }
    }
    loadUser();
  }, [addToast]);
  return (
    <div className="page">
      <h1>Home Page</h1>
      <h2>{isLoading ? "Loading..." : currentUser && currentUser.email}</h2>
    </div>
  );
};

export default HomePg;
